// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"253f4ea2","939":"94319e00"}[chunkId] + ".chunk.css";
};